module.exports = __webpack_public_path__ + "public/images/dome-tablet-h.5b3b893de3d4ba724cb04eca9b454e71.svg";